import React from "react";
import * as styles from "./CruiseSummary.module.scss";
import CruiseDepartureArrivalDates from "components/cruises/CruiseDepartureArrivalDates";
import { dequal } from "dequal/lite";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import ECommerceButtons from "components/ECommerceButtons";
import { CruisePriceAndOffersV2Response } from "src/ssc-api/prices/useCruisePrice";
import StickyCruisePrice from "./StickyCruisePrice";
import CruiseDuration from "components/cruises/CruiseDuration";

export interface CruiseSummaryProps {
  cruiseName?: string | JSX.Element;
  cruiseCode: string;
  prices?: CruisePriceAndOffersV2Response;
  departureDate?: string;
  arrivalDate?: string;
  days?: number;
  raqUrl?: string;
  ecommerceStatus: ECommerceStatus;
}

const CruiseSummary: React.FC<React.PropsWithChildren<CruiseSummaryProps>> = ({
  cruiseName,
  prices,
  departureDate,
  arrivalDate,
  days,
  raqUrl,
  ecommerceStatus,
  cruiseCode
}) => {
  return (
    <div className={styles.summary} data-content-name="sticky_cruise_summary">
      <div className={styles.name}>{cruiseName}</div>
      <div className={styles.date}>
        <span>
          <CruiseDepartureArrivalDates
            departureDate={departureDate}
            arrivalDate={arrivalDate}
          />
        </span>
        <div>
          <CruiseDuration days={days || 0} />
        </div>
      </div>
      <div className={styles.priceColumn}>
        <StickyCruisePrice
          price={prices?.priceFrom}
          cruiseCode={cruiseCode}
          departureDate={departureDate}
        />
      </div>

      <div className={styles.cta}>
        {raqUrl && (
          <ECommerceButtons
            raqUrl={raqUrl}
            size="small"
            url={ecommerceStatus}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(CruiseSummary, dequal);
